import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetVorVehicleDropdownQuery } from '../../../../api/endpoints/teamProductivityMeasurement';
import { useLanguage } from '../../../../contexts/LanguageContext';

const VorVehicleDropdown = ({ value, onChange, disabled, className }) => {
    const { getCurrentLanguageId, th } = useLanguage();
    const LanguageId = getCurrentLanguageId();

    const { data: list = [], isLoading } = useGetVorVehicleDropdownQuery({ LanguageId });

    const options = useMemo(() =>
        list.map((item) => ({
            label: item.text || item.Text,
            value: item.iD || item.id || item.ID
        })),
        [list]
    );

    return (
        <Dropdown
            value={value}
            options={options}
            onChange={(e) => onChange(e.value)}
            disabled={disabled}
            loading={isLoading}
            placeholder={th('teamProductivity.placeholders.vorVehicle')}
            showClear
            filter
            className={className}
        />
    );
};

export default VorVehicleDropdown;